(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/winner-ticker/assets/javascripts/ticker.js') >= 0) return;  svs.modules.push('/widgets/winner-ticker/assets/javascripts/ticker.js');

'use strict';

const {
  normalizeBingoWinners,
  normalizeCasinoWinners,
  addTrackingListener
} = svs.widget.winner_ticker.utils;
const {
  TickerFeed
} = svs.widget.winner_ticker.constants;
const SCROLL_BY = 350;
const MAX_NUMBER_OF_RENDERED_WINNERS = 25;
const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
const casinoMicroserviceSocket = svs.core.svsSocket.get('/v1/casino-socket');
class WinnerTicker {
  constructor(options) {
    this.options = options;
    this.el = options.$el[0];
    this.winnerListEl = this.el.querySelector('.ticker-container__winner-list');
    this.endpoint = this.options.model.feed;
    this.winnerList = this.options.model.winners;
    this.isPaused = false;
    this.socketAnimationQueue = [];
    this.animationInProgress = false;
    const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
    for (const winnerEl of this.winnerListEl.children) {
      addTrackingListener(winnerEl);
    }
    this.setupListeners();
    if (!shouldReduceMotion) {
      this.subscribeToWinners();
    }
  }
  addWinnerWithAnimation(winner) {
    this.animationInProgress = true;
    let winnerEl = document.createElement('template');
    winnerEl.innerHTML = svs.widget.winner_ticker.templates.winners({
      winner,
      shouldAnimate: true
    });
    winnerEl = addTrackingListener(winnerEl.content.firstChild);
    const eventListener = animationEvent => {
      if (animationEvent.animationName !== 'fade-in') {
        return;
      }
      this.animationInProgress = false;
      if (this.socketAnimationQueue.length) {
        const nextWinnerInQueue = this.socketAnimationQueue.shift();
        this.addWinnerWithAnimation(nextWinnerInQueue);
      }
      winnerEl.removeEventListener('animationend', eventListener);
    };
    winnerEl.addEventListener('animationend', eventListener);
    this.winnerListEl.prepend(winnerEl);
    if (this.winnerListEl.children.length > MAX_NUMBER_OF_RENDERED_WINNERS) {
      this.winnerListEl.lastElementChild.remove();
    }
  }
  queueNewItem(winner) {
    if (this.animationInProgress) {
      this.socketAnimationQueue.push(winner);
    } else {
      this.addWinnerWithAnimation(winner);
    }
  }
  pushNewWinners(incomingWinners) {
    const existingWinners = this.winnerList.concat(this.socketAnimationQueue);
    const newWinners = incomingWinners.filter(incomingWinner => !existingWinners.some(winner => winner.id === incomingWinner.id));
    for (const winner of newWinners) {
      this.winnerList.push(winner);
      this.queueNewItem(winner);
    }
  }
  onSocketUpdate(data) {
    var _data$winnerFeed;
    const winnerFeedItems = useCloudCasinoApis ? data === null || data === void 0 ? void 0 : data.winnerFeed : data === null || data === void 0 || (_data$winnerFeed = data.winnerFeed) === null || _data$winnerFeed === void 0 ? void 0 : _data$winnerFeed.items;
    if (!winnerFeedItems) {
      return;
    }
    if (this.options.model.feed === TickerFeed.BINGO) {
      var _svs$widgets;
      const incomingWinners = normalizeBingoWinners(winnerFeedItems, (_svs$widgets = svs.widgets) === null || _svs$widgets === void 0 || (_svs$widgets = _svs$widgets.winner_ticker) === null || _svs$widgets === void 0 || (_svs$widgets = _svs$widgets.data) === null || _svs$widgets === void 0 ? void 0 : _svs$widgets.bingoGames);
      this.pushNewWinners(incomingWinners);
    } else {
      this.handleIncomingCasinoWinners(winnerFeedItems);
    }
  }
  async handleIncomingCasinoWinners(winners) {
    const incomingWinners = await normalizeCasinoWinners(winners, window.location.pathname); 
    this.pushNewWinners(incomingWinners);
  }
  setupListeners() {
    if (!svs.core.detect.formfactor.mobile()) {
      const leftScrollBtn = this.el.querySelector('.ticker-container__scroll-btn-container--left');
      const rightScrollBtn = this.el.querySelector('.ticker-container__scroll-btn-container--right');
      leftScrollBtn.children[0].addEventListener('click', () => {
        this.winnerListEl.scrollBy({
          left: -SCROLL_BY,
          behavior: 'smooth'
        });
      });
      rightScrollBtn.children[0].addEventListener('click', () => {
        this.winnerListEl.scrollBy({
          left: SCROLL_BY,
          behavior: 'smooth'
        });
      });
      if (this.isOverflowing()) {
        rightScrollBtn.style.display = 'flex';
      }
      this.winnerListEl.addEventListener('scroll', () => {
        if (this.winnerListEl.scrollLeft + this.winnerListEl.clientWidth > this.winnerListEl.scrollWidth - 1) {
          rightScrollBtn.style.display = 'none';
          leftScrollBtn.style.display = 'flex';
        } else if (this.winnerListEl.scrollLeft === 0) {
          rightScrollBtn.style.display = 'flex';
          leftScrollBtn.style.display = 'none';
        } else {
          rightScrollBtn.style.display = 'flex';
          leftScrollBtn.style.display = 'flex';
        }
      });
    }
  }
  isOverflowing() {
    return this.winnerListEl.scrollWidth > this.winnerListEl.clientWidth;
  }
  subscribeToWinners() {
    if (!useCloudCasinoApis) {
      svs.core.socket.subscribe("/casino/1/winnerfeed/".concat(this.endpoint), this.onSocketUpdate, this, false, true);
    } else {
      casinoMicroserviceSocket.subscribe("/api/v1/casino/winnerfeeds/".concat(this.endpoint), data => this.onSocketUpdate(data.message.data));
    }
  }
}
setGlobal('svs.widget.winner_ticker.init', options => {
  var _options$$el$;
  if (!(options !== null && options !== void 0 && (_options$$el$ = options.$el[0]) !== null && _options$$el$ !== void 0 && (_options$$el$ = _options$$el$.dataset) !== null && _options$$el$ !== void 0 && _options$$el$.initialized)) {
    new WinnerTicker(options);
    options.$el[0].dataset.initialized = 'true';
  }
});

 })(window);